import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Footer = styled.footer`
	display: flex;
	align-items: center;
	justify-content: ${(props) => (props.centered ? 'center' : 'flex-end')};
	border-bottom-right-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
	padding: 0 2rem 1.75rem;

	& > :not(:first-child) {
		margin-left: 0.25rem;
	}

	& > :not(:last-child) {
		margin-right: 0.25rem;
	}
`;

const ModalFooter = ({ ...props }) => <Footer {...props} />;

ModalFooter.propTypes = {
	centered: PropTypes.bool
};

export default ModalFooter;
